
import { BaseModule } from '../base.module';
/**
 * 
 */
export class ProgramModule extends BaseModule {
  intersectionRatioTippingPoint = .01;
  navigationBarHeight = null;
  scrollAnimationLength = 35;
  boundScrollEventListener = this.scrollEventListener.bind(this);
  initialize() {
    let bodyStyle = getComputedStyle(document.querySelector('body'));
    if (bodyStyle) {
      let breakPoint = bodyStyle.getPropertyValue('--current-breakpoint');
      switch (breakPoint) {
        case 'xs':
        case 'sm':
          this.intersectionRatioTippingPoint = .01;
          break;
        case 'md':
          this.intersectionRatioTippingPoint = .01;
        case 'lg':
          this.intersectionRatioTippingPoint = .2;
        case 'xl':
        case 'xxl':
          this.intersectionRatioTippingPoint = .3;
          break;

        default:
          break;
      }
    }
    document.addEventListener('DOMContentLoaded', () => {
      this.tableRelativeContainers = document.querySelectorAll(".table-relative-container");
      this.programs = document.querySelectorAll(".program");
      this.programs.forEach(program => {
        if (program.dataset.program) {
          let id = program.dataset.program;
          // console.log('program dataset id is', id);
          // if the program is in a header
          if (program.closest('header')) {
            // console.log('program seems to be in the header, this is the program and id', program, id);
            let main = document.querySelector('main');
            let mainProgram = main.querySelector(`.program[data-program="${id}"]`);
            // console.log('main and main program', main, mainProgram, 'it has id', id);
            if (mainProgram) {
              // console.log('main program found:', mainProgram);
            }
          }
          let programColumnsContainer = program.querySelector(".program-columns");
          let programItemsContainer = program.querySelector(".program-items");
          let programDaysContainer = program.querySelector(".program-days");
          this.mainProgramItems = document.querySelectorAll('.main-program-item');

          let leftControl = program.querySelector(
            ".program__control--left"
          );
          let rightControl = program.querySelector(
            ".program__control--right"
          );
          let tableRelativeContainer = leftControl.closest('.program').querySelector('.table-relative-container');
          console.log('closest table relative container for controls', leftControl, 'and', rightControl, 'is', tableRelativeContainer);

          leftControl.addEventListener("click", () => this.scroll(false, tableRelativeContainer, programDaysContainer));
          rightControl.addEventListener("click", () => this.scroll(true, tableRelativeContainer, programDaysContainer));
          tableRelativeContainer.addEventListener('scroll', this.boundScrollEventListener);

          this.handleDocumentScroll(program);
        }
      });
      this.cacheProgramItemHeights();
      this.observeIntersections();
      let items = document.querySelectorAll('.program-item');
      items.forEach((item) => {
        item.addEventListener('click', (e) => {
          let body = e.target.closest('.program-item').querySelector('.program-item__body'); // initially hidden!
          if (body) {
            if (body.classList.contains('d-flex') === false) {
              body.classList.add('d-flex');
              item.classList.add('state-opened');
            } else {
              if (
                body.classList.contains('d-flex') === true
              ) {
                body.classList.remove('d-flex');
                item.classList.remove('state-opened');
              }
            }
          }
        });
      });
    });
  }

  handleDocumentScroll(program) {
    let tableRelativeContainer = document.querySelector('body').querySelector(`main .program[data-program="${program.dataset.program}"] .table-relative-container`);
    document.addEventListener('scroll', () => {
      let yAndHeight = tableRelativeContainer.getBoundingClientRect().y + tableRelativeContainer.getBoundingClientRect().height;
      if (tableRelativeContainer.getBoundingClientRect().y < 0) {
        let headerProgram = document.querySelector(`header .program[data-program="${program.dataset.program}"]`);
        if (headerProgram) {
          headerProgram.classList.add('visible');
        }
      }
      if (yAndHeight < 0) {
        let headerProgram = document.querySelector(`header .program[data-program="${program.dataset.program}"]`);
        if (headerProgram) {
          headerProgram.classList.remove('visible');
        }
      }
    })
  }
  scrollEventListener(event) {
    let closestTableRelativeContainer = event.target.closest('.program').querySelector('.table-relative-container');
    let otherRelativeTableContainers = Array.from(this.tableRelativeContainers).filter(function (c, i) {
      if (c === closestTableRelativeContainer) {
        return false;
      }
      return true;
    });
    otherRelativeTableContainers.forEach((otherRelativeTableContainer) => {
      otherRelativeTableContainer.scrollLeft = closestTableRelativeContainer.scrollLeft;
    });

    this.padMainProgramItems();
  }

  scroll(isNext = true, tableRelativeContainer, programDaysContainer) {
    this.tableRelativeContainers.forEach((tableRelativeContainer) => {
      tableRelativeContainer.removeEventListener('scroll', this.boundScrollEventListener)
    });
    let firstProgramDay = programDaysContainer.querySelector('.program-day');
    let dayWidthWithoutUnits = firstProgramDay.getBoundingClientRect().width;
    if (isNext === false) {
      dayWidthWithoutUnits = -dayWidthWithoutUnits;
    }

    let otherRelativeTableContainers = Array.from(this.tableRelativeContainers).filter(function (c, i) {
      if (c === tableRelativeContainer) {
        return false;
      }
      return true;
    });
    let nowAt = 0;
    otherRelativeTableContainers.forEach((otherRelativeTableContainer) => {
      let initialPosition = Object.assign({}, { value: tableRelativeContainer.scrollLeft }).value;
      let targetPosition = tableRelativeContainer.scrollLeft + dayWidthWithoutUnits;
      let diff = targetPosition - initialPosition;
      // recursive function with end state.
      // This uses verlett integration
      let doRequestAnimationFrame = (t) => {
        let calc = 0;
        calc = initialPosition + ((diff) * (nowAt / this.scrollAnimationLength));
        tableRelativeContainer.scrollLeft = calc;
        otherRelativeTableContainer.scrollLeft = calc;
        if (nowAt < this.scrollAnimationLength + 1) {
          requestAnimationFrame(doRequestAnimationFrame);
          // details left padding, keep in view as long as possible/sane
          this.padMainProgramItems();
        } else {
          if (nowAt >= this.scrollAnimationLength) {
            tableRelativeContainer.addEventListener('scroll', this.boundScrollEventListener);
            otherRelativeTableContainer.addEventListener('scroll', this.boundScrollEventListener);
            return; // stop it
          }
        }
        nowAt += 1;
      };
      requestAnimationFrame(doRequestAnimationFrame);
    });
  }

  padMainProgramItems() {
    this.mainProgramItems.forEach((item) => {
      if (item.getBoundingClientRect().x < 0) {
        let val = `${-(item.getBoundingClientRect().x)}px`;
        item.querySelector('.program-item__details').style.paddingLeft = val;
      }
    });
  }

  cacheProgramItemHeights() {
    this.tableRelativeContainers.forEach((tableRelativeContainer) => {
      let items = tableRelativeContainer.querySelectorAll('.program-item');
      items.forEach(item => {
        item.dataset.cachedHeight = `${item.getBoundingClientRect().height}`;
      });
    });
  }

  observeIntersections() {
    if (window.IntersectionObserver) {
      this.observeProgramItemIntersections();
      this.observeProgramNavigationIntersections();
    }
  }

  observeProgramNavigationIntersections() {
    let intersectionObserverThresholds = [];
    for (let index = 0.00; index <= 1; index = index + 0.02) {
      intersectionObserverThresholds.push(index);

    }
    let intersectionObserverConfiguration = {
      root: null,
      threshold: intersectionObserverThresholds
    };
    this.intersectionObserver = new IntersectionObserver(this.handleProgramNavigationIntersections, intersectionObserverConfiguration);
    let items = document.querySelectorAll('main .program'); // in main content
    items.forEach((item) => {
      this.intersectionObserver.observe(item);
    });
  }

  observeProgramItemIntersections() {
    this.tableRelativeContainers.forEach((tableRelativeContainer) => {
      let container = tableRelativeContainer;

      let intersectionObserverThresholds = [];
      for (let index = 0.00; index <= 1; index = index + 0.02) {
        intersectionObserverThresholds.push(index);

      }
      let intersectionObserverConfiguration = {
        root: container,
        threshold: intersectionObserverThresholds
      };
      this.intersectionObserver = new IntersectionObserver(this.handleProgramItemIntersections, intersectionObserverConfiguration);
      let items = tableRelativeContainer.querySelectorAll('.program-item');
      items.forEach((item) => {
        this.intersectionObserver.observe(item);
      });
    });
  }

  handleProgramItemIntersections = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.target) {
        /**
         * @var {IntersectionObserverEntry} entry
         */
        let target = entry.target;
        let isIntersecting = entry.isIntersecting;
        let e = entry.target.closest('.program-item-sticky-container');
        // e.style['margin-right'] = `${100 - (parseInt(e.style['margin-left']) + parseInt(e.style['max-width']))}%`;
        target.dataset.intersectionRatio = entry.intersectionRatio;

        if (entry.intersectionRatio < this.intersectionRatioTippingPoint) {
          target.classList.add('low-intersection-ratio');
          target.classList.remove('high-intersection-ratio');
        }
        if (entry.intersectionRatio >= this.intersectionRatioTippingPoint) {
          target.classList.add('high-intersection-ratio');
          target.classList.remove('low-intersection-ratio');
        }

        if (isIntersecting === true) {
          target.classList.add('is-intersecting');
          target.classList.remove('is-not-intersecting');
          let calculation = 1 * (entry.intersectionRatio.toFixed(2) * target.dataset.cachedHeight);
          // console.log(calculation);
          // !!
          if (target.classList.contains('main-program-item')) {
            target.style.minHeight = `${calculation}px`;
            e.classList.remove('is-hidden');
            e.classList.add('is-shown');
          }
          if (target.classList.contains('sub-program-item')) {
            target.style.maxHeight = `${calculation}px`;
            target.style.opacity = entry.intersectionRatio.toFixed(2);
          }


        }
        if (isIntersecting === false) {
          if (target.classList.contains('main-program-item')) {
            e.classList.add('is-hidden');
            e.classList.remove('is-shown');
          }
          target.classList.add('is-not-intersecting');
          target.classList.remove('is-intersecting');
        }
      }
    });
  };

  handleProgramNavigationIntersections = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.target) {
        /**
         * @var {IntersectionObserverEntry} entry
         */
        let target = entry.target;
        let isIntersecting = entry.isIntersecting;
        this.handleProgramNavigationScroll(entry);
      }
    });
  };
  handleProgramNavigationScroll(entry) {
    if (entry.boundingClientRect.y < 0) {
      let headerProgram = document.querySelector('header .program');
      if (headerProgram) {
        headerProgram.classList.add('visible');
      }
    } else {
      if (entry.boundingClientRect.y >= 0) {
        let headerProgram = document.querySelector('header .program');
        if (headerProgram) {
          headerProgram.classList.remove('visible');
        }
      }
    }
  }
}
